
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"#036","d":"M24 31.999c-12.952 0-24-16.001-24-16.001S11.055-.001 24-.001c12.951 0 24 15.999 24 15.999S36.944 31.999 24 31.999zm0-30c-9.809 0-18.772 10.478-21.506 13.999C5.226 19.519 14.184 29.999 24 29.999c9.808 0 18.771-10.479 21.505-14.001C42.774 12.479 33.815 1.999 24 1.999zm0 22a8 8 0 110-16 8 8 0 010 16zm0-14c-3.309 0-6 2.691-6 5.999a6.007 6.007 0 006 6.001c3.308 0 6-2.692 6-6.001a6.006 6.006 0 00-6-5.999z"}})])
          )
        }
      }
    